var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"s-upDownArrow"}},[(_vm.status == true)?_c('span',[_c('b-icon',{staticClass:"refreshColor",attrs:{"icon":"arrow-bar-up","font-scale":"1"}})],1):_c('span',[_c('b-icon',{staticClass:"refreshColor",attrs:{"icon":"arrow-bar-down","font-scale":"1"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }